import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { Nav, Collapse } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const Sidebar = (props) => {
  const location = useLocation();
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "selected" : "";
  };
  const auth_obj = useSelector((state) => state.auth);
  const {
    user: { isReputationPlanSubscribed },
  } = auth_obj;

  const [state, setState] = useState({
    authentication: activeRoute("/auth") !== "" ? true : false,
    datasheetpages: activeRoute("/datasheet") !== "" ? true : false,
    accountpages: activeRoute("/account") !== "" ? true : false,
    privacypages: activeRoute("/privacy") !== "" ? true : false,
    reputationpages: activeRoute("/reputation") !== "" ? true : false,
  });

  const settings = useSelector((state) => state.settings);

  //Language translator handler
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);

  /*--------------------------------------------------------------------------------*/
  /*To Expand SITE_LOGO With Sidebar-Menu on Hover                                  */
  /*--------------------------------------------------------------------------------*/
  const expandLogo = (isOpen) => {
    isOpen === true
      ? document.getElementById("logobg").classList.add("expand-logo")
      : document.getElementById("logobg").classList.remove("expand-logo");
  };
  /*--------------------------------------------------------------------------------*/
  /*Verifies if routeName is the one active (in browser input)                      */
  /*--------------------------------------------------------------------------------*/

  /*--------------------------------------------------------------------------------*/
  /*Its for scroll to to                    */
  /*--------------------------------------------------------------------------------*/

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const showMobilemenu = () => {
    if (window.innerWidth < 800) {
      document.getElementById("main-wrapper").classList.toggle("show-sidebar");
    }
  };

  const renderAnchorTag = (prop, key) => (
    <li
      onClick={scrollTop}
      className={
        activeRoute(prop.path) +
        (prop.pro ? " active active-pro" : "") +
        " sidebar-item"
      }
      key={key}
    >
      <a
        href={prop.path}
        target={prop.target}
        rel="noreferrer"
        className="sidebar-link"
      >
        {prop.icon ? <i className={prop.icon} /> : <i>{prop.reactIcon}</i>}
        <span
          className="hide-menu text-wrap text-left"
          style={{ lineHeight: "120%" }}
        >
          {t(prop.name)}
        </span>
      </a>
    </li>
  );

  const renderNavLink = (prop, key) => (
    <li
      onClick={scrollTop}
      className={
        activeRoute(prop.path) +
        (prop.pro ? " active active-pro" : "") +
        " sidebar-item"
      }
      key={key}
    >
      <NavLink
        target={prop.target}
        to={prop.path}
        onClick={showMobilemenu}
        className="sidebar-link"
        // activeClassName="active"
      >
        {prop.icon ? <i className={prop.icon} /> : <i>{prop.reactIcon}</i>}
        <span className="hide-menu">{t(prop.name)}</span>
      </NavLink>
    </li>
  );

  return (
    <aside
      className="left-sidebar"
      id="sidebarbg"
      data-sidebarbg={"skin7" || settings.activeSidebarBg}
      onMouseOver={() => expandLogo(true)}
      onMouseLeave={() => expandLogo(false)}
    >
      <div className="scroll-sidebar">
        <PerfectScrollbar className="sidebar-nav">
          {/*--------------------------------------------------------------------------------*/}
          {/* Sidebar Menus will go here                                                */}
          {/*--------------------------------------------------------------------------------*/}
          <Nav id="sidebarnav">
            {props.routes
              .filter(({ hide }) => !hide)
              .map((prop, key) => {
                if (
                  prop.redirect ||
                  (prop.hideForNoneReputationUsers &&
                    !isReputationPlanSubscribed)
                ) {
                  return null;
                } else if (prop.navlabel) {
                  return (
                    <li className="nav-small-cap" key={key}>
                      {prop.icon ? (
                        <i className={prop.icon}></i>
                      ) : (
                        <i>{prop.reactIcon}</i>
                      )}
                      <h6 className="hide-menu m-0">{t(prop.name)}</h6>
                    </li>
                  );
                  /*--------------------------------------------------------------------------------*/
                  /* Child Menus wiil be goes here                                                    */
                  /*--------------------------------------------------------------------------------*/
                } else if (prop.collapse) {
                  let firstdd = {};
                  firstdd[prop.state] = !state[prop.state];

                  return (
                    <li
                      className={activeRoute(prop.path) + " sidebar-item"}
                      key={key}
                    >
                      <span
                        data-toggle="collapse"
                        className="sidebar-link has-arrow"
                        aria-expanded={state[prop.state]}
                        onClick={() => setState(firstdd)}
                      >
                        {prop.icon ? (
                          <i className={prop.icon} />
                        ) : (
                          <i>{prop.reactIcon}</i>
                        )}
                        <span
                          className="hide-menu m-0 text-wrap text-center"
                          style={{ lineHeight: "120%" }}
                        >
                          {t(prop.name)}
                        </span>
                      </span>
                      <Collapse isOpen={state[prop.state]}>
                        <ul className="first-level">
                          {prop.child.map((prop, key) => {
                            if (
                              prop.redirect ||
                              (prop.hideForNoneReputationUsers &&
                                !isReputationPlanSubscribed)
                            )
                              return null;
                            return !prop.target
                              ? renderNavLink(prop, key)
                              : renderAnchorTag(prop, key);
                          })}
                        </ul>
                      </Collapse>
                    </li>
                  );
                } else {
                  /*--------------------------------------------------------------------------------*/
                  /* Adding Sidebar Item                                                            */
                  /*--------------------------------------------------------------------------------*/
                  return !prop.target
                    ? renderNavLink(prop, key)
                    : renderAnchorTag(prop, key);
                }
              })}
          </Nav>
        </PerfectScrollbar>
      </div>
    </aside>
  );
};

Sidebar.propTypes = {
  routes: PropTypes.array.isRequired,
};

export default Sidebar;
